import {
    Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
    ModalBody, ModalFooter, Table, TableContainer, Thead, Tbody, Tr, Th, Td,
    Text, useDisclosure,
} from '@chakra-ui/react'

const formatValue = (value) => {
    if (value === null || value === undefined) return 'Not set'
    if (value === '') return 'Empty string'
    if (typeof value === 'object') return JSON.stringify(value)
    return String(value)
}

const formatChangedAt = (value) => {
    if (!value) return '—'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return String(value)
    return date.toLocaleString(undefined, {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        fractionalSecondDigits: 3, timeZoneName: 'short', hour12: false,
    })
}

export const RowHistory = ({rowName, history}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const changes = Array.isArray(history) ? history : []

    return (
        <>
            <Button size='sm' variant='outline' isDisabled={changes.length === 0} mr={2} onClick={onOpen} aria-label={`View history for row ${rowName}`}>
                History
            </Button>
            <Modal isOpen={isOpen} onClose={onClose} size='4xl' scrollBehavior='inside'>
                <ModalOverlay />
                <ModalContent mx={4}>
                    <ModalHeader pr={12}>History — Row {rowName}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {changes.length ? (
                            <>
                                <Text fontSize='sm' color='gray.600' mb={4}>
                                    Times are shown in your local time zone.
                                </Text>
                                <TableContainer>
                                    <Table size='sm' variant='striped'>
                                        <Thead>
                                            <Tr>
                                                <Th>Changed at</Th>
                                                <Th>Field</Th>
                                                <Th>Previous value</Th>
                                                <Th>New value</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {changes.map((change, index) => (
                                                <Tr key={index}>
                                                    <Td>{formatChangedAt(change.changed_at)}</Td>
                                                    <Td title={change.field} whiteSpace='normal'>
                                                        {change.field?.replace(/_/g, ' ') ?? '—'}
                                                    </Td>
                                                    <Td whiteSpace='pre-wrap' overflowWrap='anywhere'>{formatValue(change.old_value)}</Td>
                                                    <Td whiteSpace='pre-wrap' overflowWrap='anywhere'>{formatValue(change.new_value)}</Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            </>
                        ) : (
                            <Text color='gray.600'>No changes recorded for this row.</Text>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={onClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
